import { IIRPJDataSource } from "@/features/contabil/dashboardTributacao/widgets/cruzamento/types";
import { Cruzamento } from "@/features/contabil/dashboardTributacao/widgets/cruzamento/useCruzamentoFilterStore";
import { IRPJResponse } from "../../requests/types";
import EmpresaMapper from "@/features/contabil/common/EmpresaMapperAdapter";

export default class IRPJ {
  constructor(readonly response: IRPJResponse | undefined) {}

  handleTableData(tipoCruzamento: Cruzamento): IIRPJDataSource[] {
    return (
      this.response?.empresas.map((empresa) => ({
        empresa: EmpresaMapper.toEntity(empresa),
        diferenca: empresa[tipoCruzamento]?.diferenca,
        dctf: empresa[tipoCruzamento]?.aPagarDctf,
        ecf: empresa[tipoCruzamento]?.aPagarEcf
      })) || []
    );
  }

  hasNull(tipoCruzamento: Cruzamento): boolean {
    return (
      this.response?.empresas?.some(
        (empresa) =>
          !empresa[tipoCruzamento]?.diferenca ||
          !empresa[tipoCruzamento]?.aPagarDctf ||
          !empresa[tipoCruzamento]?.aPagarEcf
      ) || false
    );
  }
}
